<ion-tabs>
  <ion-tab-bar slot="bottom" *ngIf="!hideMenu">
    <ion-tab-button tab="home">
      <ion-icon name="home"></ion-icon>
      Home
    </ion-tab-button>
    <ion-tab-button tab="order">
      <ion-icon name="folder"></ion-icon>
      Auftrag
    </ion-tab-button>
    <ion-tab-button tab="products">
      <ion-icon name="reader"></ion-icon>
      Produkte
    </ion-tab-button>
    <ion-tab-button tab="contacts">
      <ion-icon name="person"></ion-icon>
      Kontakte
    </ion-tab-button>
    <ion-tab-button tab="settings">
      <ion-icon name="settings"></ion-icon>
      Einstellungen
    </ion-tab-button>
  </ion-tab-bar>
</ion-tabs>
